import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "@shared/services/toast";
import { GET_USER_PROFILE_QUERY_KEY } from "./useGetUserProfile";

type Props = {
  onSuccess?: () => void;
};

export const useRemoveUserProfileAvatar = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await api.userControllerRemoveUserAvatar();
      queryClient.invalidateQueries({ queryKey: [GET_USER_PROFILE_QUERY_KEY] });
      onSuccess?.();
      return response;
    },
    onError: (error) => {
      console.error(`Failed to remove profile photo`, error);
      toast.error(`Failed to remove profile photo`);
    },
  });

  return mutation;
};
